import React, { useContext, useEffect, useState } from 'react';
import { WizardContext } from 'context/Context';
import { useNavigate } from 'react-router-dom';
import { Form, Row, Button } from 'react-bootstrap';
import Wrapper from './components/Wrapper';
import { getTimeWindow } from './components/Confirmed';
import { ConfigContext } from 'context/Context';
import { beforeToday } from 'si/helpers/beforeToday';

function ConfirmPlumbing() {
  const { fabricator } = useContext(ConfigContext);
  const { job, handleAppointmentConfirmation } = useContext(WizardContext);
  const navigate = useNavigate();
  const [decision, setDecision] = useState('');
  const [rescheduleConfirm, setRescheduleConfirm] = useState(false);
  const [reason, setReason] = useState('');
  const [decided, setDecided] = useState(false);

  useEffect(() => {
    // console.log('plumbingInstall status', job?.plumbingInstall?.status);
    console.log('job', job);
    if (
      job.id &&
      (!job.plumbingInstall ||
        job?.plumbingInstall?.reschedule ||
        beforeToday(job?.plumbingInstall?.date) ||
        job?.plumbingInstall?.status === 'Installed' ||
        job?.plumbingInstall?.status === 'In Progress')
    ) {
      navigate('../');
    }
  }, [job.id, job?.plumbingInstall?.status]);

  useEffect(() => {
    if (job?.plumbingInstall?.windowAnswered) {
      setDecided(true);
      if (job.plumbingInstall.windowConfirmed) {
        setDecision('confirm');
      } else if (job.plumbingInstall.reschedule) {
        setDecision('reschedule');
        navigate('../');
      } else {
        navigate('../');
      }
    }
  }, [job?.plumbingInstall]);

  return decided ? (
    <Wrapper>
      <div className="container">
        <h5>Plumbing Arrival Window Confirmed</h5>
        <p>Fantastic - we look forward to seeing you!</p>
        <p>Quick Checklist to be ready:</p>
        <ul>
          <li>Please have all fixtures in the area they belong</li>
          <li>Clean out area under the sinks</li>
        </ul>
        {/* <Alert variant="secondary">
          Note: If we’re unable to install your plumbing due to unpreparedness,
          there will be an "unable to install" fee.
        </Alert> */}
        <p>
          <em>
            NOTE: We do not install new appliances, such as dishwashers and
            ranges.
          </em>{' '}
          If you have questions, please reach out to your project coordinator,{' '}
          {job?.PC.firstName} at{' '}
          <a href={`tel:1-${job?.PC?.phone || '800-548-4445'}`}>
            {job?.PC?.phone || '800.548.4445'}
          </a>
          .
        </p>
        <p style={{ fontStyle: 'italic' }}>
          If you have an emergency that requires you to reschedule, please call{' '}
          <a href={fabricator.phonelink}>{fabricator.phone}</a>
        </p>
      </div>
    </Wrapper>
  ) : (
    <Wrapper>
      <div className="container">
        <h5>Confirm Plumbing Arrival Window</h5>

        <Row>
          <p>
            It’s time to get things flowing! Your Plumbing Reconnect appointment
            is scheduled for {job?.plumbingInstall?.dateFormatted}, with our
            team arriving between{' '}
            <strong>
              {job?.plumbingInstall?.time &&
                getTimeWindow(job?.plumbingInstall?.time)}
            </strong>{' '}
            to complete the final step!{' '}
          </p>
          <p className="fs--1">
            Click your choice below to move forward with your project:
          </p>
        </Row>

        <Form className="outdoor-field">
          <Row className="pl-3">
            <Form.Check
              type="radio"
              name="decision"
              id="confirm"
              label={`Perfect - see you there`}
              checked={decision === 'confirm'}
              onChange={() => {
                setDecision('confirm');
              }}
            />
          </Row>
          <Row className="pl-3">
            <Form.Check
              type="radio"
              name="reschedule"
              id="yes"
              label={<>I need to reschedule</>}
              checked={decision === 'reschedule'}
              onChange={() => {
                setDecision('reschedule');
              }}
            />
          </Row>
        </Form>
        {decision === 'reschedule' && (
          <>
            <p>Are you sure you need to reschedule?</p>
            <p>
              Just a heads up - if we reschedule, we'll have to find the next
              available date.
            </p>
            <Form>
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  id="textOK"
                  label="Yes, please contact me to reschedule"
                  checked={rescheduleConfirm}
                  onChange={({ target }) =>
                    setRescheduleConfirm(target.checked)
                  }
                  inline
                />
              </Form.Group>
              {rescheduleConfirm && (
                <>
                  <p className="fs--1" style={{ fontStyle: 'italic' }}>
                    Are there any scheduling concerns we should be aware of
                    while we look for a new date for you?{' '}
                  </p>
                  <Form.Group>
                    <Form.Control
                      as="textarea"
                      bssize="sm"
                      id="experienceDescription"
                      value={reason}
                      onChange={({ target }) => setReason(target.value)}
                      rows={5}
                      className="mb-3"
                    />
                  </Form.Group>
                </>
              )}
            </Form>
          </>
        )}
        <Button
          color="primary"
          className="mx-2 my-1 save-comment-btn"
          disabled={
            !decision || (decision === 'reschedule' && !rescheduleConfirm)
          }
          onClick={() => {
            handleAppointmentConfirmation({
              type: 'plumbing',
              decision,
              reason
            });
            if (decision === 'confirm') {
              setDecided(true);
            } else {
              navigate('../');
            }
          }}
        >
          Submit My Selection
        </Button>
      </div>
    </Wrapper>
  );
}

export default ConfirmPlumbing;
